<template>

        <div v-if="!paid" ref="paypalButtonContainer" class="paypal-button-container"></div>    
    
    </template>

<script>
import { loadScript } from '@paypal/paypal-js';
export default {
  name: 'VueExMXN',
  data() {
    return {
      paid: false,
    };
  },
  props: {
    cartTotal: {
      type: Number,
      default: 0.01,
    },
  },
  mounted() {
    loadScript({ 'client-id': CLIENT_ID, currency: 'MXN' }).then((paypal) => {
      paypal
        .Buttons({
          style: {
            layout: 'vertical',
            shape: 'rect',
            height: 54,
            color: 'black',
            tagline: false,
          },
          createOrder: this.createOrder,
          onApprove: this.onApprove,
        })
        .render(this.$refs.paypalButtonContainer);
    });
  },
  methods: {
    createOrder: function(data, actions) {
      console.log('Creating order MXN...');
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: this.cartTotal,
              currency_code: 'MXN', // Force MXN currency
            },
          },
        ],

        application_context: {
        shipping_preference: 'NO_SHIPPING'
      }
      });
    },
    onApprove: function(data, actions) {
      console.log('Order approved...');
      console.log(data)
      let tran_id=data.orderID
      console.log(tran_id)
      return actions.order.capture().then(() => {
        this.paid = true;
       
        this.$emit('messageFromPaypalMXN', tran_id)
        //emit
        console.log('Order complete');
      });
    },
  },
};
const CLIENT_ID = 'ASBsW-vGnNIzt-UnyZh3_FHirYsqa3alWmdHPpjEYp-HaCH1lFaTWvVShCOZuiRpu4kwvb-GDItEm4RM';
</script>



<style>
.paypal-button-container {
  width: 100%;
  margin: 0;
}

.paypal-button-container > div,
.paypal-button-container > div > div {
  width: 100% !important;
  max-width: none !important;
}

.paypal-button-container .paypal-buttons,
.paypal-button-container iframe {
  width: 100% !important;
  max-width: none !important;
}
#confirmation {
  color: green;
  margin-top: 1em;
  font-size: 2em;
}
</style>
